import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en-US'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) =>
      import(`../locales/${language}/${namespace}.json`)
    )
  )
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    defaultNS: 'common',
    ns: ['common', 'dna-explanations', 'pills', 'deck'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'madboat-language',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });

/**
 * Get current locale string for use in Intl APIs and toLocaleDateString.
 * Use this instead of hardcoding 'pt-BR'.
 */
export function getLocale(): string {
  return i18n.language || 'pt-BR';
}

export default i18n;
